import React from 'react';
import { useSplitPane } from '../layout/SplitPaneLayout';

/**
 * RefineButton - Opens the refine co-pilot panel
 * 
 * DEX Standard: Text button "Refine Results" not icon
 * KAI Standard: < 2 clicks to refine
 */
export default function RefineButton({ onClick, className = '' }) {
  const { openPanel, isOpen } = useSplitPane();
  
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
    openPanel();
  };
  
  // Don't show if panel is already open
  if (isOpen) return null;
  
  return (
    <button
      onClick={handleClick}
      className={`
        px-4 py-2 rounded-lg text-sm font-medium 
        text-[#5a20ff] bg-[#5a20ff]/10 
        hover:bg-[#5a20ff]/20 
        transition-all duration-200 
        hover:scale-105 active:scale-95
        ${className}
      `}
      style={{ fontFamily: "'Playfair Display', serif" }}
    >
      Refine Results
    </button>
  );
}
